import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';
import FichaMTR from '../../views/PesquisaMTR/FichaMTR';

//Api
import agenda_api from '../../api/agenda_api';
import MTR_api from '../../api/MTR_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../helpers/ValidadorDeCampos';

//Localizer do calendario
const localizer = momentLocalizer(moment);

//Estado inicial dos filtros
function initialStateFiltros() {

    const dataInicial = new Date();
    dataInicial.setDate(dataInicial.getDate() - 31);
    const dataFinal = new Date();
    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD"),
        localidadeId: null,
        localidadeId_selected: null
    }

}
export default function AgendaColetas() {
    //Estado de controle dos campos de filtros obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios dos filtros
    const campos = [
        objCampo({ name: "localidadeId_selected", required: true }),
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true })
    ]
    //Estado da mtr escolhida
    const [mtr, setMtr] = useState(null);

    //Estado que guarda as opções dos endereços
    const [enderecos, setEnderecos] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado que guarda os valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Lista de eventos do calendario
    const [eventos, setEventos] = useState([]);

    //onChange para os campos de filtros
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        });
    }

    //onChange para o campo de localidade
    const onChangeLocalidade = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : null
        });
    }

    //onClick em cada evento da agenda
    const onClickEvento = (e) => {
        if (e.idMtr != 0 && e.idMtr != null) {
            setLoading(true);
            MTR_api.GetList({ idMtr: e.idMtr }).then(response => {
                setMtr(response.data[0]);
            }).catch(e => showMessage('Aviso', e.message, "error", null))
                .finally(f => setLoading(false))
        }
    }
    //Textos convertidos para br do calendario
    const defaultMessages = {
        date: 'Data',
        time: 'Tempo',
        event: 'Evento',
        allDay: 'Dia Todo',
        week: 'Semana',
        work_week: 'Semana de trabalho',
        day: 'Dia',
        month: 'Mês',
        previous: '<',
        next: '>',
        yesterday: 'Ontem',
        tomorrow: 'Amanhã',
        today: 'Hoje',
        agenda: 'Agenda',
        noEventsInRange: 'Não existe eventos neste intervalo.',
        showMore: function showMore(total) {
            return "+" + total + " mais";
        }
    };
    //Carrega os eventos de acordo com os filtros passados
    const carregaItems = () => {

        const _filtros = { ...filtros };

        agenda_api.GetLocalidadesGerador().then(response => {
            response.data = response.data.map(value => {
                return { label: value.endereco, value: value.id }
            })
            setEnderecos(response.data);

            if (response.data.length === 1) {
                _filtros.localidadeId = response.data[0].value;
                _filtros.localidadeId_selected = response.data[0];
                setFiltros({ ..._filtros });
            }
            const _errors = validarCampos(_filtros, campos);
            if (new Date(_filtros.dataInicial).getTime() > new Date(_filtros.dataFinal).getTime()) {
                _errors[0].dataInicial = { message: "Data inicial é maior do que data final" };
                _errors[1].push("dataInicial");
            }

            if (((new Date(_filtros.dataFinal) - new Date(_filtros.dataInicial)) / (1000 * 60 * 60 * 24)) > 31) {
                _errors[0].dataInicial = { message: "Intervalo entre as datas maior do que 31 dias" };
                _errors[1].push("dataInicial");
            }

            setErrors(_errors[0]);

            if (_errors[1].length > 0) {
                setLoading(false);
                return;
            }

            carregaEventos(_filtros);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(setLoading(false));
    }
    const carregaEventos = (filtrosParam = null) => {
        setLoading(true);
        const _filtros = filtrosParam ? filtrosParam : { ...filtros };

        if (_filtros.dataInicial) {
            _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        }

        if (_filtros.dataFinal) {
            _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        }

        agenda_api.GetList(_filtros).then(eventos => {
            eventos.data = eventos.data.map(value => {

                const item = {
                    idMtr: value.idMtr,
                    start: new Date(value.dataFinal),
                    end: new Date(value.dataFinal),
                    title: value.descricao,
                    backgroundColor: value.corDeFundo
                };

                return item;
            });
            setEventos(eventos.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    //Carrega os itens da agenda assim que a tela é carregada
    useEffect(() => {
        carregaItems();
    }, []);
    if (mtr)
        return <FichaMTR btnVoltar={() => setMtr(null)} mtrParam={mtr} filtros={{ idMtr: mtr.codigoMTR }} agenda />

    return (
        <MainCard title={"Agenda de coletas"}>
            {loading && <Loading />}
            <div className={`filtros`}>
                <Row>
                    <Col md="12" lg="4" className='mb-2'>
                        <TextField invalid={!!errors.dataInicial} label={"* Início"} type="date" value={filtros.dataInicial} name={"dataInicial"} onChange={onChangeFiltros} />
                        <PrintValidate field={"dataInicial"} errors={errors} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField invalid={!!errors.dataFinal} label={"* Fim"} type="date" value={filtros.dataFinal} name={"dataFinal"} onChange={onChangeFiltros} />
                        <PrintValidate field={"dataFinal"} errors={errors} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField invalid={!!errors.localidadeId_selected} label={"* Localidade"} options={enderecos} type="select" value={filtros.localidadeId_selected} name={"localidadeId_selected"} onChange={onChangeLocalidade} searchable />
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="6">
                        <Button color='info text-light' onClick={() => carregaItems()}><FontAwesomeIcon icon={faSearch} className="me-3" />Filtrar</Button>
                    </Col>
                </Row>
            </div>
            <Calendar
                eventPropGetter={(event) => {
                    return {
                        style: {
                            backgroundColor: event.backgroundColor ? event.backgroundColor : '#3f51b5',
                            borderRadius: '8px',
                            minHeight: '10px',
                        },
                    };
                }}
                localizer={localizer}
                events={eventos}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500, width: "100%" }}
                className={"mt-4"}
                messages={defaultMessages}
                popup={true}
                onDoubleClickEvent={onClickEvento}
                selectable
                resizable
            />
            <h5 className='pt-4 pb-2'>Legenda</h5>
            <Row className='mb-4'>
                <Col sm="6" md="4" lg="3" className='d-flex align-items-center'>
                    <div className='rounded-3' style={{ width: "30px", height: "30px", backgroundColor: "#3498DB" }}></div><span className='ms-2 fw-bold'> Aguardando Programação</span>
                </Col>
                <Col sm="6" md="4" lg="3" className='d-flex align-items-center'>
                    <div className='rounded-3' style={{ width: "30px", height: "30px", backgroundColor: "#2ECC71" }}></div><span className='ms-2 fw-bold'> Coletado</span>
                </Col>
                <Col sm="6" md="4" lg="3" className='d-flex align-items-center'>
                    <div className='rounded-3' style={{ width: "30px", height: "30px", backgroundColor: "#F1C40F" }}></div><span className='ms-2 fw-bold'> Não Coletado</span>
                </Col>
                <Col sm="6" md="4" lg="3" className='d-flex align-items-center'>
                    <div className='rounded-3' style={{ width: "30px", height: "30px", backgroundColor: "#E74C3C" }}></div><span className='ms-2 fw-bold'>Não Executado / Não Programado</span>
                </Col>

            </Row>
        </MainCard>
    )
}